<template>
  <div
    :data-type="context.type"
    :class="context.classes.element"
  >
    <!-- :class="`formulate-input-element formulate-input-element--${context.class}`" should already be added -->
    <div
      v-if="isListbox"
      class="d-flex flex-column gap-2 h-100"
    >
      <div class="d-flex gap-3 flex-fill advancedselect-listbox">
        <div class="w-50">
          <Listbox
            :value="multiSelectedObjects"
            :options="localOptions"
            :optionLabel="labelField"
            :optionDisabled="disabledField"
            listStyle="max-height: 300px"
            :dataKey="dataKey"
            :filter="true"
            filterPlaceholder="Search..."
            :multiple="multiple"
            class="w-100"
            v-bind="context.attributes"
            @input="handleSelection"
          >  <!-- disabled prop/attr is passed through v-bind="context.attributes" -->
          </Listbox>
        </div>

        <div
          class="w-50 d-flex flex-column border rounded selections-wrapper bg-white-50"
          style="max-height: 350px; overflow-y: auto"
        >
          <div v-if="multiSelectedObjects.length === 0" key="noListboxSelections" class="h-100 d-flex align-items-center justify-content-center">
            <div class="text-center text-muted">No Selections</div>
          </div>
          <div v-else key="hasListboxSelections">
            <div
              v-for="obj in multiSelectedObjects"
              :key="obj[dataKey]"
              class="selected-item bg-white d-flex justify-content-between align-items-center p-2"
            >
              <div class="">{{ obj[labelField] }}</div>
              <div>
                <b-button v-if="!readOnly" variant="minimal-secondary" size="sm" class="text-uppercase font-size-70 px-1" @click="handleDeselect(obj)">Remove</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="special-text font-size-80 text-gray-700">
        {{ localOptionsCount ? `${localSelectionsCount} of ${localOptionsCount} selected` : 'No Options'  }}
      </div>
    </div>
    <MultiSelect
      v-else-if="multiple"
      :value="multiSelectedObjects"
      :options="localOptions"
      :optionLabel="labelField"
      :optionDisabled="disabledField"
      :dataKey="dataKey"
      :filter="localShowFilter"
      :placeholder="placeholder"
      :showToggleAll="showToggleAll"
      display="chip"
      :selectionLimit="selectionLimit"
      class="w-100"
      v-bind="context.attributes"
      @input="handleSelection"
      @before-show="onBeforeShow"
      @hide="context.blurHandler"
    >  <!-- disabled prop/attr is passed through v-bind="context.attributes" -->
      <!-- @input="handleSelection" optionValue="id" - up/down arrows did not work when using optionValue -- it screws up what is shown in value slot I think -->
      <template #indicator>
        <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
        <!-- had to add this slot, even though it has default -->
      </template>
      <!-- <template #value="slotProps">
              <div v-if="loadingOptions" key="loadingOptions" class="text-muted">
                  <b-spinner small class="text-muted mr-1"></b-spinner>
                  Loading...
              </div>
              <div v-else-if="slotProps.value && slotProps.value.length > 0" class="d-flex flex-wrap gap-2" key="hasValue">
                  TODO - may need/want to customize the value display -- this was from other component you built
                  <tenant-user-badge
                      v-for="tu in slotProps.value"
                      :key="tu.id"
                      :tu-data="tu"
                  ></tenant-user-badge>
              </div>
          </template> -->
      <template #option="slotProps">
        <div
          v-if="loadingOptions"
          key="loadingOptions"
        >
          <b-spinner
            small
            class="text-muted mr-1"
          ></b-spinner>
          Loading...
        </div>
        <div
          v-else
          key="optionsLoaded"
          class="dropdown-options-item"
        >
          <div>{{ slotProps.option[labelField] }}</div>
        </div>
      </template>
    </MultiSelect>
    <Dropdown
      v-else
      :value="selectedObj"
      :options="localOptions"
      :optionLabel="labelField"
      :optionDisabled="disabledField"
      :dataKey="dataKey"
      :filter="localShowFilter"
      :placeholder="placeholder"
      :showClear="true"
      class="w-100"
      v-bind="context.attributes"
      @input="handleSelection"
      @before-show="onBeforeShow"
      @hide="context.blurHandler"
    > <!-- disabled prop/attr is passed through v-bind="context.attributes" -->
      <!-- appendTo="body" optionValue="id" - up/down arrows did not work when using optionValue -- it screws up what is shown in value slot I think -->
      <template #indicator>
        <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
        <!-- had to add this slot, even though it has default -->
      </template>
      <template #value="slotProps">
        <transition
          name="fade-fast"
          mode="out-in"
        >
          <div
            v-if="slotProps.value"
            class="text-wrap"
            >{{ slotProps.value[labelField] }}</div
          >
          <span
            v-else-if="loadingOptions"
            class="text-muted"
          >
            <b-spinner
              small
              class="text-muted mr-1"
            ></b-spinner>
            <!-- <i class="pi pi-spin pi-spinner" /> -->
            Loading...
          </span>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </transition>
      </template>
      <template #option="slotProps">
        <div
          v-if="loadingOptions"
          key="loadingOptions"
        >
          <b-spinner
            small
            class="text-muted mr-1"
          ></b-spinner>
          Loading...
        </div>
        <div
          v-else
          key="optionsLoaded"
          class="dropdown-options-item text-wrap"
        >
          <div>{{ slotProps.option[labelField] }}</div>
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script>
  import { errorHandling } from '../../js/custom-vue-mixins';
  import { splAxiosBare, suppliosApi } from '../../js/api-service';
  import Dropdown from 'primevue/dropdown';
  import MultiSelect from 'primevue/multiselect';
  import Listbox from 'primevue/listbox';
  import get from 'lodash/get';
  import invoke from 'lodash/invoke';

  // formulate custom inputs:  must read from and write to context.model

  export default {
    name: 'FormulateAdvancedSelect',
    components: {
      Dropdown,
      MultiSelect,
      Listbox,
    },
    mixins: [errorHandling],
    props: {
      context: {
        // the required Formulate context prop
        type: Object,
        required: true,
      },
      multiple: {
        // if true, we use Multiselect and value is always an Array, even if selectionLimit = 1
        type: Boolean,
        default: false,
      },
      selectionLimit: {
        // OPTIONAL if multiple=false, this is ignored  (will show a Dropdown, not Multiselect)
        type: Number,
        required: false,
      },
      url: {
        // if we should get options from a URL, pass that here (absolute or relative)
        type: String,
        required: false,
      },
      apiEndpoint: {
        // instead of URL, provide dotted string name of suppliosApi endpoint, without the suppliosApi part -- so 'vendorStandard.list'
        // could also just pass in the actual endpoint function too (from parent component)
        // this will win if both apiEndpoint and url are provided as props
        type: [String, Function],
        required: false,
      },
      apiEndpointArgs: {
        // any needed args to use when calling apiEndpoint -- we use ...args when invoking it
        type: Array,
        required: false,
      },
      resultsKey: {
        // the key where the array of options is inside the fetched options (from url or apiEndpoint)
        // like 'results' if its paginated
        type: String,
        required: false,
      },
      labelField: {
        // must have this -- the thing to use in the option object as label
        type: String,
        default: 'label',
      },
      valueField: {
        // OPTIONAL - if undefined, we store the entire option object.  if you provide something here, we store that key from the object
        type: String,
        required: false,
      },
      disabledField: {
        // field on each option object to use for disabled
        type: String,
        default: 'disabled',
      },
      dataKey: {
        // unique property in the option objects, needed for doing the v-for in Dropdown component (default is 'id')
        type: String,
        default: 'id',
      },
      options: {
        // NOTE - passed options array likely won't be here... if you have classification for this component set to something that has options
        // instead, they will be in context.options (the formulate context object) - that's why you have a passedOptions computed - that checks both places
        type: Array,
        required: false,
      },
      showFilter: {
        type: Boolean,
        default: null, // we only honor this if set explicitly true/false
      },
      inputType: {
        // options: 'listbox', 'select'
        type: String,
        default: 'select',
      },
      showToggleAll: {
        // only for MultiSelect
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        loadingOptions: false,
        fetchedOptions: null, // we fetch when user clicks on dropdown - use null until we know we've fetched them
        // FOR SINGLE SELECT
        selectedObj: null, // we set this explicitly using getSelectedObj()
        selectedValue: null, // could be a string or object, depending on valueField
        // FOR MULTISELECT
        multiSelectedObjects: [], // the multi version of selectedObj
        multiSelectedValues: [], // the multi version of selectedValue - could be array of objects OR array of strings (values/ids)
      };
    },
    computed: {
      localModel() {
        return this.context.model;
      },
      passedOptions() {
        // the directly-passed options - could be at this.options or this.context.options (just to cover both... depends on field 'classification' it seems)
        // returns null if there are no arrays in either place
        const rawOptions = this.options || this.context.options;
        return !!rawOptions && Array.isArray(rawOptions) ? [...rawOptions] : null;
      },
      hasRemoteOptions() {
        // are options remote?  meaning we fetch them at 'url' or 'apiEndpoint' - if passing them in directly, then this should be false
        return !!this.url || !!this.apiEndpoint;
      },
      localOptions() {
        // warning... if you set 'classification' to something that does not have options prop, then context.options = false
        if (this.hasRemoteOptions) {
          return this.fetchedOptions ?? [{ id: 'LOADING' }]; // should be array of option objects - need to transform/rekey?
        } else {
          return this.passedOptions ?? [];
        }
      },
      localOptionsCount() {
        // how many options do we have?  the local list of options, no matter where they came from
        return this.localOptions?.length ?? 0;
      },
      localSelectionsCount() {
        // how many selections do we have?  the local list of selected objects, no matter where they came from
        return this.multiple ? this.multiSelectedObjects?.length ?? 0 : this.selectedObj ? 1 : 0;
      },
      localShowFilter() {
        // should we actually show the filter for finding options?  Boolean
        // by default, we will show it if there are more than 10 options
        // but we can explicitly shot/not show by using the showFilter prop
        if ([true, false].includes(this.showFilter)) {
          return this.showFilter;
        }
        return this.localOptionsCount > 10;
      },
      readOnly() {
        // this is for later... for showing in complete read-only mode
        return this.context.attributes?.disabled ?? false;
      },
      placeholder() {
        const defaultPlaceholder = this.localOptionsCount > 0 ? 'Select...' : 'No options';
        return this.context.attributes?.placeholder ?? (this.context.placeholder || defaultPlaceholder); // placeholder might show up in multiple places... by default it is always in context.placeholder, but might be boolean false, so we || to a default
      },
      //   inputType() {
      //     return this.context.attributes?.input_type ?? (this.context.input_type || 'select');
      //   },
      labelOrName() {
        // just for debug help
        return this.context.label ?? this.context.name ?? 'unknown';
      },
      isListbox() {
        return this.inputType === 'listbox';
      },
    },
    watch: {
      'context.model': {
        handler: 'setLocalValue',
        immediate: true,
      },
    },
    async mounted() {
      //console.log('in mounted for FormulateAdvancedSelect - context is', JSON.stringify(this.context, null, 2));
      // do we already have a selected value?  if not an object, just the ID, then we need to get options now
      // TODO - if in READ ONLY mode, then you may not want to get the whole list
      //      (because you might have vendors looking at in, like in a workflow)
      //      in that case, you may want to just do a retrieve() instead of list() from API
      // we'll fetchOptions right away no matter what - just make sure it passes through without error if you don't have apiEndpoint or url set
      await this.fetchOptions();
    },
    methods: {
      handleDeselect(obj) {
        // handle deselecting an object from the multiSelectedObjects array
        // we need to remove it from multiSelectedObjects and then emit the new array
        const newMultiSelectedObjects = this.multiSelectedObjects.filter((selObj) => selObj[this.dataKey] !== obj[this.dataKey]);
        this.multiSelectedObjects = [...newMultiSelectedObjects];
        this.multiSelectedValues = newMultiSelectedObjects.map((selObj) => this.valueGetter(selObj));
        this.context.model = this.multiSelectedValues;
      },
      onBeforeShow() {
        console.log('in onBeforeShow');
        // if we havne't fetched options yet, then do it now
        if (!this.fetchedOptions) {
          this.fetchOptions();
        }
      },
      async fetchOptions() {
        this.loadingOptions = true;
        try {
          //const { data } = await suppliosApi.vendorStandard.list();
          //const { results } = data;
          //this.fetchedOptions = results ? [ ...results ] : [];  // its paginated.... - default to empty list so we know we've fetched once
          //const { data } = await suppliosApi.vendorStandard.list_options();
          let respData;
          if (this.apiEndpoint) {
            const finalEndpointArgs = this.apiEndpointArgs || [];
            if (typeof this.apiEndpoint === 'function') {
              const resp = await this.apiEndpoint(...finalEndpointArgs); // have not tested this...
              respData = resp.data;
            } else {
              // assume its a string, invoke it
              const resp = await invoke(suppliosApi, this.apiEndpoint, ...finalEndpointArgs);
              respData = resp.data;
            }
          } else if (this.url) {
            const resp = await splAxiosBare.get(this.url);
            respData = resp.data;
          } else {
            respData = [];
          }
          //const { data } = await splAxiosBare.get(this.url);
          if (respData && this.resultsKey) {
            this.fetchedOptions = respData[this.resultsKey];
          } else {
            this.fetchedOptions = Array.isArray(respData) ? respData : [];
          }
        } catch (err) {
          this.apiErrorHandler(err);
        }
        // after fetching options, we should update local selections from localValues (localSelections are always objects, set by finding options that match localValue)
        this.setLocalSelection();
        this.loadingOptions = false;
      },
      valueGetter(optObj) {
        if (this.valueField) {
          return optObj ? get(optObj, this.valueField) : ''; // default to empty string if we''re supposed
        } else {
          return optObj ? { ...optObj } : null; // returning shallow copy
        }
      },
      dataKeyGetter(optObj) {
        return get(optObj, this.dataKey);
      },
      handleSelection(selection) {
        // HANDLE THE SELECTION FROM UNDERLYING PRIMEVUE COMPONENT
        // SINGLE: incoming arg will be the full object -- from the Dropdown component
        // MULTI:  incoming arg will be ARRAY of full objects -- from the MultiSelect component
        // NOTE - before Feb 4 2023, we were not reactive to context.model being updated from external source, but we should be
        //      - we will change this to NOT set local values/v-model values (this.selectedObj/multiSelectedObjects)
        //          but instead just set context.model
        //      - then put a watcher on this.context.model to update local values (this.selectedObj/multiSelectedObjects)
        //          whether context.model is changed by selection, or from external thing
        console.log('in handleSelection, selection is', selection);
        if (this.multiple) {
          const multiSelectedValues = !!selection && Array.isArray(selection) ? selection.map((selObj) => this.valueGetter(selObj)) : [];
          this.context.model = multiSelectedValues;
        } else {
          const selectedValue = this.valueGetter(selection); // make sure to go through valueGetter, so we make copy if its object
          this.context.model = selectedValue;
        }
      },
      setLocalValue(value, oldValue) {
        // handler for setting local value when this.context.model changes from something external
        //   or when context.model is changed from user selection (we set it in method above)
        // call this from watcher on context.model
        // value could be:
        //      if multiple:  array of values (strings) if we have valueField, or array of objects
        //      if not multiple: single value (string) if we have valueField, or single object
        // NOTE - if options are not loaded yet (ie: if we have to fetch from remote) then we CANNOT set local selected object(s) - only values
        //              then we have to set local selected object(s) after options are loaded
        const isDifferent = value !== oldValue;
        //console.log(`in setLocalValue for [${this.labelOrName}] value is`, value, 'oldValue is', oldValue, 'isDifferent?', isDifferent);
        if (!isDifferent) {
          // ONLY proceed with setLocalSelection if we have a real change - otherwise we'll have excessive updates
          return;
        }
        if (this.multiple) {
          this.multiSelectedValues = !!value && Array.isArray(value) ? [...value] : [];
        } else {
          this.selectedValue = value ? value : null; // null or '' as default?
        }
        this.setLocalSelection(); // try setting local selected object(s) now that you set local values -- but will only work if you already have options loaded
      },
      setLocalSelection() {
        // set the local selected object(s) (this.selectedObj / this.multiSelectedObjects)
        //      from local values (this.selectedValue / this.multiSelectedValues)
        //      the local selected object(s) are the values actually passed to underlying primevue components for their v-model
        // you must have options loaded for this to do anything - but you can (should) have local VALUES already set
        // so if you call it before remote options are loaded, you should call again once options are loaded
        if (this.multiple) {
          this.multiSelectedObjects = this.getMultiSelectedObjects(); // gets from multiSelectedValues - what gets passed to value of primevue component - should always be objects
        } else {
          this.selectedObj = this.getSelectedObj(); // gets from selectedValue - this is what is passed to value of underlying primevue component, should always be object
        }
        // July 19 2023 - calling context.blurHandler here to trigger changes in our workflow form components
        //this.context.blurHandler();
      },
      getSelectedObj() {
        // might be same as selectedValue if we store the full object, or not if we have something for valueField
        // ONLY FOR SINGLE SELECT
        // MUST HAVE OPTIONS LOADED FOR THIS TO WORK
        if (!this.selectedValue) {
          return null;
        }
        if (this.valueField) {
          return this.localOptions.find((optObj) => this.valueGetter(optObj) == this.selectedValue);
        } else {
          return this.selectedValue || null; // return shallow copied object itself, or null in case selectedValue is empty (initial selectedValue from parent will be empty string)
        }
      },
      getMultiSelectedObjects() {
        // get objects from values - only for MULTIPLE select
        // MUST HAVE OPTIONS LOADED FOR THIS TO WORK
        if (!this.multiSelectedValues || !Array.isArray(this.multiSelectedValues) || !this.multiSelectedValues.length) {
          return [];
        }
        // if here, then we have a value (array)
        if (this.valueField) {
          // if we have valueField, then values are IDs
          const selectedObjs = this.localOptions.filter((optObj) => this.multiSelectedValues.includes(this.valueGetter(optObj)));
          return [...selectedObjs];
        } else {
          // if here, then the values are objects themselves... but we'll compare using dataKey -- we should always have that, and comparing object vs. object is always tricky
          const selectedKeys = this.multiSelectedValues.map((selObj) => this.dataKeyGetter(selObj));
          const selectedObjs = this.localOptions.filter((optObj) => selectedKeys.includes(this.dataKeyGetter(optObj)));
          return [...selectedObjs];
        }
      },
    },
  };
</script>

<style lang="scss">
  .formulate-input-element .p-multiselect-label {
    /* Normally .p-multiselect-label is display: block, but then chips do not wrap... looks ugly */
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .advancedselect-listbox {
    .selections-wrapper {
      .selected-item {
        border-bottom: 1px solid var(--gray-200);
      }
    }
  }

</style>
